module.exports = __webpack_public_path__ + "img/buy.678cbf3e.gif";